import { graphql, useStaticQuery } from "gatsby"

export const useInstaPosts = () => {
  const { instaPosts } = useStaticQuery(graphql`
    query InstagramPosts {
      instaPosts: allInstaNode(limit: 6) {
        edges {
          node {
            caption
            localFile {
              childImageSharp {
                fluid(maxWidth: 242, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  `)

  return { instaPosts }
}
